<template>
  <div>
    <div
      id="layout"
      style="visibility: visible;"
    >
      <div
        id="north"
        class="north"
      >
        <header-info cur="3"></header-info>
      </div>
      <div
        id="center"
        class="center_box"
      >
        <div
          id="main"
          class="main clearfix"
        >
          <div
            id="leftmenu"
            class="leftmenu"
          >
            <div class="leftmenu-item">
              <p class="p1">课程建设</p>
              <ul class="leftmenu-list">
                <li
                  class="li1"
                  :class="menuSelected == '/online/basic' ? 'on' : ''"
                  @click="updateMenuSelected"
                >
                  <router-link :to="`/online/basic?id=${lessonOnline_id}`"><i class="iconfont"></i>基本信息
                  </router-link>
                </li>
                <li
                  class="li1"
                  :class="menuSelected == '/online/content' ? 'on' : ''"
                  @click="updateMenuSelected"
                >
                  <router-link :to="`/online/content?id=${lessonOnline_id}`"><i class="iconfont"></i>内容管理
                  </router-link>
                </li>
                <li
                  class="li1"
                  :class="menuSelected == '/online/class' ? 'on' : ''"
                  @click="updateMenuSelected"
                >
                  <router-link :to="`/online/class?id=${lessonOnline_id}`"><i class="iconfont"></i>班级管理
                  </router-link>
                </li>
                <li
                  class="li1"
                  :class="menuSelected == '/online/question' ? 'on' : ''"
                  @click="updateMenuSelected"
                >
                  <router-link :to="`/online/question?id=${lessonOnline_id}`"><i class="iconfont"></i>题库管理
                  </router-link>
                </li>
              </ul>
            </div>
            <div class="leftmenu-item">
              <p class="p1">教学管理</p>
              <ul class="leftmenu-list">
                <li
                  class="li1"
                  :class="menuSelected == '/online/student' ? 'on' : ''"
                  @click="updateMenuSelected"
                >
                  <router-link :to="`/online/student?id=${lessonOnline_id}`"><i class="iconfont"></i>选课学生</router-link>
                </li>
                <li
                  class="li1"
                  :class="menuSelected == '/online/discuss' || menuSelected == '/online/discuss/detail' ? 'on' : ''"
                  @click="updateMenuSelected"
                >
                  <router-link :to="`/online/discuss?id=${lessonOnline_id}`"><i class="iconfont"></i>讨论答疑</router-link>
                </li>
                <li
                  class="li1"
                  :class="menuSelected == '/online/grade' ? 'on' : ''"
                  @click="updateMenuSelected"
                >
                  <router-link :to="`/online/grade?id=${lessonOnline_id}`"><i class="iconfont"></i>课程成绩管理</router-link>
                </li>
                <li
                  class="li1"
                  :class="menuSelected == '/online/experiment_grade' ? 'on' : ''"
                  @click="updateMenuSelected"
                >
                  <router-link :to="`/online/experiment_grade?id=${lessonOnline_id}`"><i class="iconfont"></i>实验成绩管理</router-link>
                </li>
                <li
                  class="li1"
                  :class="menuSelected == '/online/research' ? 'on' : ''"
                  @click="updateMenuSelected"
                >
                  <router-link :to="`/online/research?id=${lessonOnline_id}`"><i class="iconfont"></i>调查问卷</router-link>
                </li>
              </ul>
            </div>
            <div class="leftmenu-item">
              <p class="p1">课程统计</p>
              <ul class="leftmenu-list">
                <li
                  class="li1"
                  :class="menuSelected == '/online/statistics/course' ? 'on' : ''"
                  @click="updateMenuSelected"
                >
                  <router-link :to="`/online/statistics/course?id=${lessonOnline_id}`"><i class="iconfont"></i>课程统计报告</router-link>
                </li>
                <li
                  class="li1"
                  :class="menuSelected == '/online/statistics/study' ? 'on' : ''"
                  @click="updateMenuSelected"
                >
                  <router-link :to="`/online/statistics/study?id=${lessonOnline_id}`"><i class="iconfont"></i>学习数据统计</router-link>
                </li>
              </ul>
            </div>
          </div>
          <div id="panel-wrap">
            <router-view
              :lessonInfo="lessonInfo"
              v-if="lessonInfo"
            ></router-view>
          </div>
        </div>
      </div>
      <div id="south">
        <footer-info></footer-info>
      </div>
    </div>
    <div
      id="dialog_overlay"
      :style="showMsgWindow"
    >
      <div id="dialog_bg"></div>
      <div
        id="dialog_panel"
        style="margin-left: -136px; margin-top: -54px;max-width: 300px;"
      >
        <div id="dialog_panel_bg"></div>
        <div id="dialog_title">提示</div>
        <div id="dialog_content">{{ msgText }}</div>
        <div id="dialog_content2">
          <span
            v-for="item in errorList"
            v-bind:key="item"
          >{{ item }}</span>
        </div>
        <div id="dialog_control">
          <a
            href="javascript:void(0)"
            id="dialog_close"
            @click="hideMsg"
            class="button"
            :style="this.msgType == 1? 'display:inline-block': 'display:none'"
          >取消</a>
          <a
            href="javascript:void(0)"
            id="dialog_ok"
            @click="confirmMsg"
            :class="this.msgType == 1? 'button': 'button col2'"
            :style="this.msgType == 2? 'display:none': 'display: inline-block'"
          >确认</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderInfo from '../../components/HeaderInfo'
import FooterInfo from '../../components/FooterInfo'

export default {
  name: 'LessonOnlineLayout',
  components: {
    HeaderInfo,
    FooterInfo
  },
  data: function () {
    return {
      lessonInfo: null,
      menuSelected: '',
      showMsgWindow: {},
      msgText: '',
      msgType: 0,
      errorList: [],
      lessonOnline_id: 0
    }
  },
  methods: {
    updateMenuSelected() {
      const url = window.location.href
      const arrUrl = url.split('//')
      const start = arrUrl[1].indexOf('/')
      let relUrl = arrUrl[1].substring(start)

      if (relUrl.indexOf('?') !== -1) {
        relUrl = relUrl.split('?')[0]
      }
      relUrl = relUrl.replace('#', '')
      this.menuSelected = relUrl
      this.lessonOnline_id = this.$route.query.id
      this.getLesson()
    },
    showMsg(text, callback = '') {
      this.msgType = 0
      this.msgText = text
      this.showMsgWindow = {
        visibility: 'visible'
      }
      this.confirmCallback = callback
    },
    showConfirm(text, callback) {
      this.msgType = 1
      this.msgText = text
      this.showMsgWindow = {
        visibility: 'visible'
      }
      this.confirmCallback = callback
    },
    pushError(err) {
      this.errorList.push(err)
    },
    hideMsg() {
      this.msgText = ''
      this.showMsgWindow = {}
    },
    confirmMsg() {
      this.msgText = ''
      this.showMsgWindow = {}
      if (this.confirmCallback) {
        this.confirmCallback()
        this.confirmCallback = ''
      }
    },
    FunisShow(role) {
      if (role === '') {
        return true
      } else if (parseInt(role) === 1) {
        return true
      } else if (parseInt(role) === 2) {
        return true
      } else if (parseInt(role) === 3) {
        return false
      }
    },
    async saveOnline(title, id) {
      const url = '/lesson_online/' + id + '/'
      await this.$http.put(url, {
        title: title,
        status: 1
      }).then((data) => {
        if (data.id) {
          this.$layer.msg('提交成功！')
          this.$router.push({
            path: '/admin/lesson'
          })
        } else {
          this.$layer.msg('修改失败！')
        }
      }).catch((error) => {
        console.log(error)
        this.$layer.msg('修改失败！')
      })
    },
    async getLesson() {
      const url = '/lesson_online/' + this.$route.query.id + '/'
      await this.$http.get(url).then((data) => {
        this.lessonInfo = data
      }).catch(() => {
        this.$layer.msg('获取课程信息失败！')
      })
    }
  },
  created() {
    this.getLesson()
  },
  mounted() {
    this.updateMenuSelected()
  },
  // 计算属性
  computed: {
    localUser() {
      return this.$store.state.userInfo
    }
  }
}
</script>

<style scoped>
</style>
